import script from "./FormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDialog.vue?vue&type=script&setup=true&lang=js"

import "./FormDialog.vue?vue&type=style&index=0&id=698a4c26&lang=css"

const __exports__ = script;

export default __exports__